module.exports = __webpack_public_path__ + "static/media/ic_hs_pay_freq.e7ff1b77.svg";